import { useEffect, useRef } from 'react';

export const useTransitionEffect = <V,>(
  callback: (value: V) => void,
  value: V,
  from: V
) => {
  const previous = useRef<V>(value);

  useEffect(() => {
    if (previous.current === from && value !== previous.current) {
      callback(value);
    }
    previous.current = value;
  }, [value, from]);
};
